import { appUrl } from "../utils/appUrl";
import React, { useState, useEffect, useCallback } from "react";
import { Tabs, Tab, Form, InputGroup, Button } from "react-bootstrap";
import AllActiveUsers from "../component/AllActiveUsers";
import AllDeactiveUsers from "../component/AllDeactiveUsers";
import Newusers from "./../component/Newusers";
import CreateAdminModal from "../component/CreateAdminModal";
import { useTranslation } from "react-i18next";

const UsersTabsPage = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("newuser");
  const [keyword, setKeyword] = useState("");
  const [showCreate, setShowCreate] = useState(false);

  useEffect(() => {
    const savedTab = localStorage.getItem("activeTab");
    if (savedTab) {
      setActiveTab(savedTab);
    }
  }, []);

  const handleTabSelect = (key) => {
    setActiveTab(key);
    localStorage.setItem("activeTab", key);
  };

  const handleCreateClose = useCallback(() => setShowCreate(false), []);

  const logOut = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
  };

  return (
    <div className="p-4">
      {/* Logout link */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <img
          src={appUrl("/optia.png")}
          alt={t("usersTabsPage.logo_alt")}
          style={{ height: "50px" }}
        />
        <h2 className="text-primary fw-semibold m-0">
          {t("usersTabsPage.title")}
        </h2>
        <div className="d-flex align-items-center gap-3">
          <Button
            variant="primary"
            size="sm"
            onClick={() => setShowCreate(true)}
          >
            {t("createUser.button")}
          </Button>
          <a
            onClick={logOut}
            href={appUrl("/")}
            style={{ textDecoration: "underline", fontWeight: "bold" }}
          >
            {t("usersTabsPage.logout")}
          </a>
        </div>
      </div>

      {/* Search Input */}
      <InputGroup className="mb-3">
        <Form.Control
          placeholder={t("usersTabsPage.search_placeholder")}
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
        />
      </InputGroup>

      {/* Tabs */}
      <Tabs
        activeKey={activeTab}
        onSelect={handleTabSelect}
        id="user-tabs"
        className="mb-3"
      >
        <Tab eventKey="newuser" title={t("usersTabsPage.tab.newuser")}>
          <Newusers keyword={keyword} />
        </Tab>
        <Tab eventKey="allactive" title={t("usersTabsPage.tab.allactive")}>
          <AllActiveUsers keyword={keyword} />
        </Tab>
        <Tab eventKey="alldeactive" title={t("usersTabsPage.tab.alldeactive")}>
          <AllDeactiveUsers keyword={keyword} />
        </Tab>
      </Tabs>
      <CreateAdminModal
        show={showCreate}
        handleClose={handleCreateClose}
      />
    </div>
  );
};

export default UsersTabsPage;
